const Lock = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 3.5A2.5 2.5 0 0 0 9.5 6v1.5h5V6A2.5 2.5 0 0 0 12 3.5m3.5 4V6a3.5 3.5 0 1 0-7 0v1.5h-1A2.5 2.5 0 0 0 5 10v7.5A2.5 2.5 0 0 0 7.5 20h9a2.5 2.5 0 0 0 2.5-2.5V10a2.5 2.5 0 0 0-2.5-2.5zm-8 1A1.5 1.5 0 0 0 6 10v7.5A1.5 1.5 0 0 0 7.5 19h9a1.5 1.5 0 0 0 1.5-1.5V10a1.5 1.5 0 0 0-1.5-1.5z"
      clipRule="evenodd"
    />
  </>
)
export default Lock
